/**
 * Header stamped on comparison-only (shadow) search requests so the service and any downstream
 * dashboard can distinguish them from the request that actually served the user.
 */
export const SHADOW_REQUEST_HEADER = 'X-Search-Shadow';

/**
 * Suffix appended to the scenariotag of a shadow request.
 */
export const SHADOW_SCENARIO_TAG_SUFFIX = 'shdw';

/**
 * Marks a request as comparison-only. The backend a shadow targets is chosen by the caller through
 * the separate endpointTarget parameter, so it is deliberately not repeated here.
 */
export interface ShadowRequestOptions {
    isShadow: true;
}
